import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import emailjs from "emailjs-com";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_f6qpmie",
        "template_y8h0myv",
        formData,
        "ue1japEYODKjLR_iZ"
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error(error.text);
        }
      );
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <MenuNav />
      <MobileMenu />

      <div className="container py-5">
        <Helmet>
          <title>Contactez-nous | TheBridgeOfWorld.com</title>
          <meta
            name="description"
            content="Une question sur nos véhicules importés ? Besoin d’aide pour passer commande ou obtenir un devis ? Contactez The Bridge of World dès maintenant."
          />
          <meta
            name="keywords"
            content="The bridge, contact voiture importée, support client The Bridge of World, demande d'information véhicule, devis voiture occasions, importation véhicule Afrique"
          />
          <meta name="author" content="The Bridge of World" />
          <meta
            property="og:title"
            content="Contactez-nous | TheBridgeOfWorld.com"
          />
          <meta
            property="og:description"
            content="Discutez avec notre équipe pour en savoir plus sur nos véhicules d'occasions ou neufs importés. Réponse rapide assurée."
          />
          <meta property="og:url" content="https://thebridgeofworld.com/contact" />
          <meta property="og:type" content="website" />
        </Helmet>

        <h2 className="text-center mb-4 fw-bold text-primary">Contactez-nous</h2>

        <div className="row justify-content-center">
          <div className="col-md-8">
            {success && (
              <div className="alert alert-success">
                Message envoyé avec succès !
              </div>
            )}

            <form
              onSubmit={handleSubmit}
              className="bg-white p-4 shadow-sm rounded border"
            >
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Nom
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Envoyer
              </button>
            </form>
          </div>
        </div>

        <section className="bg-light mt-5 p-4 rounded shadow-sm border">
          <h3 className="fw-bold text-center mb-4 text-dark">
            🚗 Pourquoi choisir THE BRIDGE ?
          </h3>
          <div className="row text-center">
            <div className="col-md-4 mb-3">
              <i className="bi bi-patch-check-fill text-primary fs-3"></i>
              <h6 className="fw-semibold mt-2">Qualité vérifiée</h6>
              <p className="text-muted small">
                Chaque véhicule est minutieusement inspecté pour garantir votre
                sécurité.
              </p>
            </div>
            <div className="col-md-4 mb-3">
              <i className="bi bi-tags-fill text-warning fs-3"></i>
              <h6 className="fw-semibold mt-2">Prix compétitifs</h6>
              <p className="text-muted small">
                Des offres attractives et des prix sans surprise sur tout notre
                catalogue.
              </p>
            </div>
            <div className="col-md-4 mb-3">
              <i className="bi bi-people-fill text-success fs-3"></i>
              <h6 className="fw-semibold mt-2">Satisfaction client</h6>
              <p className="text-muted small">
                Une équipe à l'écoute et un accompagnement personnalisé jusqu'à
                la livraison.
              </p>
            </div>
          </div>
        </section>

        <section className="mt-5">
          <div className="row g-4">
            <div className="col-md-6">
              <iframe
                title="Google Maps THE BRIDGE"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3172.941797015525!2d1.2255108153336285!3d6.1319354955713405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1020f7271c1237a7%3A0x8ef2e591ab9d9c5d!2sLom%C3%A9!5e0!3m2!1sfr!2stg!4v1615562368240!5m2!1sfr!2stg"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded shadow-sm"
              ></iframe>
            </div>

            <div className="col-md-6 d-flex align-items-center justify-content-center">
              <a
                href="https://wa.me/22878815494"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-lg shadow d-flex align-items-center gap-2"
              >
                <i className="bi bi-whatsapp fs-4"></i>
                Nous contacter sur WhatsApp
              </a>
            </div>
          </div>
        </section>
      </div>

      <footer
        style={{ backgroundColor: "#0C1E47" }}
        className="text-white pt-5 pb-3 mt-5 border-top"
      >
        <div className="container">
          <div className="row gy-4">
            <div className="col-md-4">
              <div className="logo-wrapper">
                <img
                  src="/BRIDGE BLANC.png"
                  alt="THE BRIDGE logo"
                  width="180"
                  className="mb-3"
                />
              </div>
              <p style={{ color: "#F7931E", fontWeight: 500 }}>
                Let’s connect the world together
              </p>
              <p className="small text-white-50">
                THE BRIDGE est votre partenaire de confiance pour l’achat de
                véhicules fiables à travers le monde.
              </p>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">Navigation</h6>
              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="text-white-50 text-decoration-none">
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link
                    to="/catalogue"
                    className="text-white-50 text-decoration-none"
                  >
                    Nos véhicules
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white-50 text-decoration-none"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link
                    to="/mentions-legales"
                    className="text-white-50 text-decoration-none"
                  >
                    Mentions légales
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">Nous contacter</h6>
              <p className="text-white-50 small mb-1">
                <i className="bi bi-geo-alt me-2"></i>Lomé, Togo
              </p>
              <p className="text-white-50 small mb-1">
                <i className="bi bi-envelope me-2"></i>
                contact@thebridgeofworld.com
              </p>
              <p className="text-white-50 small mb-0">
                <i className="bi bi-phone me-2"></i>+228 78 81 54 94 / +228 99 41 00
                41 / +228 93 90 72 95
              </p>
            </div>
          </div>

          <div className="text-center mt-4 pt-3 border-top border-secondary text-white-50 small">
            © {new Date().getFullYear()} THE BRIDGE — Tous droits réservés
          </div>
        </div>
      </footer>
    </>
  );
}
